namespace GeniuzPOS.PosShift {
    export class PsPosShiftControlColumns {
        static columnsKey = 'PosShift.PsPosShiftControl';
    }
}
